import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=04a5d2c9&"
import script from "./UserInfo.vue?vue&type=script&lang=ts&"
export * from "./UserInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a5d2c9')) {
      api.createRecord('04a5d2c9', component.options)
    } else {
      api.reload('04a5d2c9', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=04a5d2c9&", function () {
      api.rerender('04a5d2c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserInfo.vue"
export default component.exports